/* eslint-disable import/prefer-default-export */
export const createActionSet = actionName => ({
    PENDING: `${actionName}_PENDING`,
    SUCCESS: `${actionName}_SUCCESS`,
    ERROR: `${actionName}_ERROR`,
    actionName,
  });
